import { View } from 'components/View'
import { SubscriptionFreePlan } from 'pages/Premium/FreeVsPremiumFeatures/SubscriptionPlans/Free'
import { SubscriptionPremiumPlan } from 'pages/Premium/FreeVsPremiumFeatures/SubscriptionPlans/Premium'
import React from 'react'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import isSmallScreenViewportSelect from 'modules/viewport/selectors/is-small-screen'
import { SubscriptionPremiumPlusPlan } from 'pages/Premium/FreeVsPremiumFeatures/SubscriptionPlans/PremiumPlus/index.js'

const SUBSCRIPTION_PLANS = [
  SubscriptionFreePlan,
  SubscriptionPremiumPlan,
  SubscriptionPremiumPlusPlan
]

/**
 * @param props
 * @param props.areFeaturesPressable
 * @param props.isReadOnly
 * @param props.shouldBoldMainFeatures
 * @returns {Element}
 * @constructor
 */
export function SubscriptionPlans ({
  areFeaturesPressable,
  isReadOnly,
  shouldBoldMainFeatures
}) {
  const isSmallScreen = useSelector(isSmallScreenViewportSelect)
  const subscriptionPlans = [...SUBSCRIPTION_PLANS]

  return (
    <View
      style={{
        justifyContent: isSmallScreen
          ? undefined
          : View.JUSTIFY.CENTER,
        alignItems: isSmallScreen
          ? View.ALIGN.CENTER
          : undefined,
        flexDirection: isSmallScreen
          ? 'column-reverse'
          : View.DIRECTION.ROW
      }}
    >
      {
        subscriptionPlans.map((SubscriptionPlan, index) => {
          return (
            <View
              key={index}
              mt={index > 0 && isSmallScreen ? 2 : 0}
              ml={index > 0 && !isSmallScreen ? 2 : 0}
            >
              <SubscriptionPlan
                isReadOnly={isReadOnly}
                areFeaturesPressable={areFeaturesPressable}
                shouldBoldMainFeatures={shouldBoldMainFeatures}
              />
            </View>
          )
        })
      }
    </View>
  )
}
